const CONSTANTS = {
	// Login request 
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',


	// for sing-up
	SINGUP_REQUEST: 'SINGUP_REQUEST',
	SINGUP_SUCCESS: 'SINGUP_SUCCESS',
	SINGUP_FAILURE: 'SINGUP_FAILURE',

	// Citation Cards Details
	POST_CITATION_CARD_REQUEST: 'POST_CITATION_CARD_REQUEST',
	POST_CITATION_CARD_SUCCESS: 'POST_CITATION_CARD_SUCCESS',
	POST_CITATION_CARD_FAILURE: 'POST_CITATION_CARD_FAILURE',

	// get Citation Details
	GET_CITATION_DETAILS_REQUEST: 'GET_CITATION_DETAILS_REQUEST',
	GET_CITATION_DETAILS_SUCCESS: 'GET_CITATION_DETAILS_SUCCESS',
	GET_CITATION_DETAILS_FAILURE: 'GET_CITATION_DETAILS_FAILURE',


	// //booking before payment ACTION CONSTANTS
	BEFORE_PASS_PAYMENT_INITIAL_REQUEST: 'BEFORE_PASS_PAYMENT_INITIAL_REQUEST',
	BEFORE_PASS_PAYMENT_INITIAL_SUCCESS: 'BEFORE_PASS_PAYMENT_INITIAL_SUCCESS',
	BEFORE_PASS_PAYMENT_INITIAL_FAILURE: 'BEFORE_PASS_PAYMENT_INITIAL_FAILURE',

	//booking after payment ACTION CONSTANTS
	AFTER_PASS_PAYMENT_INITIAL_REQUEST: 'AFTER_PASS_PAYMENT_INITIAL_REQUEST',
	AFTER_PASS_PAYMENT_INITIAL_SUCCESS: 'AFTER_PASS_PAYMENT_INITIAL_SUCCESS',
	AFTER_PASS_PAYMENT_INITIAL_FAILURE: 'AFTER_PAYMENT_INITIAL_FAILURE',


	GET_PARTNER_DETAILS_REQUEST: 'GET_PARTNER_DETAILS_REQUEST',
	GET_PARTNER_DETAILS_REQUEST_SUCCESS: 'GET_PARTNER_DETAILS_REQUEST_SUCCESS',
	GET_PARTNER_DETAILS_REQUEST_FAIL: 'GET_PARTNER_DETAILS_REQUEST_FAIL',

	// GET PARTNER DETAILS
	GET_PARTNER_DETAILS_BY_SLUG_REQUEST: 'GET_PARTNER_DETAILS_BY_SLUG_REQUEST',
	GET_PARTNER_DETAILS_BY_SLUG_SUCCESS: 'GET_PARTNER_DETAILS_BY_SLUG_SUCCESS',
	GET_PARTNER_DETAILS_BY_SLUG_FAILURE: 'GET_PARTNER_DETAILS_BY_SLUG_FAILURE',

	// for the appeal create
	POST_CREATE_APPEAL_REQUEST: 'POST_CREATE_APPEAL_REQUEST',
	POST_CREATE_APPEAL_SUCCESS: 'POST_CREATE_APPEAL_SUCCESS',
	POST_CREATE_APPEAL_FAILURE: 'POST_CREATE_APPEAL_FAILURE',

	// HANDLE EVENT LOGS

	ADD_EVENT_LOG_REQUEST: 'ADD_EVENT_LOG_REQUEST',
	ADD_EVENT_LOG_SUCCESS: 'ADD_EVENT_LOG_SUCCESS',
	ADD_EVENT_LOG_FAILURE: 'ADD_EVENT_LOG_FAILURE',

	// get vehicle  constant
	GET_VEHICLE_REQUEST: 'GET_VEHICLE_REQUEST',
	GET_VEHICLE_SUCCESS: 'GET_VEHICLE_SUCCESS',
	GET_VEHICLE_FAILURE: 'GET_VEHICLE_FAILURE',

	// for the void create
	POST_CREATE_VOID_REQUEST: 'POST_CREATE_VOID_REQUEST',
	POST_CREATE_VOID_SUCCESS: 'POST_CREATE_VOID_SUCCESS',
	POST_CREATE_VOID_FAILURE: 'POST_CREATE_VOID_FAILURE',
}
export default CONSTANTS
